import {
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'otk-forensics-ui',
});

export const detailRouteRef = createSubRouteRef({
  id: 'otk-forensics-ui/details',
  path: '/details/:itemRef/:pod/:container/*',
  parent: rootRouteRef,
});
